import { AuthContent, AuthContext } from '@admin/components/auth'
import TextField from '@admin/components/form/textfield'
import Avatar from '@admin/components/avatar'
import Button from '@admin/components/button'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

class Security extends React.Component {

  static contextTypes = {
    network: PropTypes.object
  }

  static propTypes = {
    account: PropTypes.object,
    security_question: PropTypes.string,
    token: PropTypes.string,
    onNext: PropTypes.func
  }

  state = {
    answer: '',
    message: null,
    status: 'pending'
  }

  _handleNext = this._handleNext.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)

  render() {
    return (
      <AuthContext.Consumer>
        {(authContext) => {
          this._authContext = authContext
          return this._renderContent()
        }}
      </AuthContext.Consumer>
    )
  }

  _renderContent() {
    const { account, security_question } = this.props
    const { message } = this.state
    return (
      <AuthContent>
        <div className="maha-auth-form">
          <div className="maha-auth-content">
            { account && <Avatar user={ account } width="150" presence={ false } /> }
            { account && <h2>{ account.full_name }</h2> }
            <p>Hi { account.first_name }. Before we can reset your password, Please
            answer the following security question to prove your identity.</p>
            <p>{ security_question }</p>
          </div>
          { message &&
            <div className="maha-auth-error">
              <T text={ message } />
            </div>
          }
          <div className="ui form">
            <div className="field text-field">
              <TextField { ...this._getAnswer() } />
            </div>
            <div className="field">
              <Button { ...this._getContinue() } />
            </div>
          </div>
        </div>
      </AuthContent>
    )
  }

  _getAnswer() {
    return {
      placeholder: 't(Answer)',
      autocomplete: 'off',
      onChange: this._handleUpdate.bind(this, 'answer')
    }
  }

  _getContinue() {
    const { status } = this.state
    return {
      label: 't(Continue)',
      loading: status === 'submitting',
      color: 'blue',
      size: 'large',
      handler: this._handleSubmit
    }
  }

  _handleNext() {
    this.props.onNext('password')
  }

  _handleSubmit() {
    const { token } = this.props
    const { answer } = this.state
    this.setState({ status: 'submitting' })
    this.context.network.request({
      endpoint: '/api/admin/reset/security',
      method: 'POST',
      body: {
        token,
        answer
      },
      onSuccess: this._handleNext,
      onFailure: ({ message }) => {
        this._authContext.shake()
        this.setState({
          message,
          status: 'pending'
        })
      }
    })
  }

  _handleUpdate(key, value) {
    this.setState({
      [key]: value
    })
  }

}

export default Security
